import { observer } from 'mobx-react'

import type PolicyPeriod from 'modules/payroll_bundle/store/models/PolicyPeriod'
import policyAuthorizations from 'modules/permissions/store/collections/policyAuthorizations'

import { SupplementsByDateAndFrequency } from './SupplementsByDateAndFrequency'
import { SupplementsByPeriod } from './SupplementsByPeriod'

interface SupplementsProps {
  policyPeriod?: PolicyPeriod | null
  bulkImportSupplementStage?: string
  itemToHighlight?: { employeeId: string } | null
}

const BatchedSupplements = (props: SupplementsProps) => {
  if (policyAuthorizations.for('payroll_supplements.supplements.read'))
    return <SupplementsByPeriod {...props} />

  return <SupplementsByDateAndFrequency />
}

export default observer(BatchedSupplements)
